"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f322 = void 0;
exports.f322 = {
    "łəw’ál’məš": [
        1408
    ],
    "łingít": [
        7568,
        7569
    ]
};
